<div class="p-heading-area01">
  <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'label.itinerary1' | staticMsg"></h2>
  <div class="p-heading-area01__sub-function">
    <ng-container *ngIf="isAwardBookingFlag">
      <a
        href="#"
        id="search-flight-body-pres-link-1"
        class="c-text-link-arrow01"
        (throttleClick$)="clickAwardFlight($event)"
        [innerHTML]="'label.awardBooking' | staticMsg"
        aswThrottleClick
      ></a>
    </ng-container>
  </div>
</div>
<asw-tabs
  #tabComponent
  [activeNum]="this.tabIndex"
  (selectEvent)="clickTabEvent($event)"
  id="search-flight-body-pres-tabs-1"
>
  <asw-tabs-item title="{{ 'label.roundTripSelect' | staticMsg }}">
    <asw-roundtrip
      #roundTripComponent
      [props]="this.props"
      [information]="information"
      [isEnabled]="this.tabIndex === 0"
      [isJapanOnlyFlag]="this.isJapanOnlyFlag"
      [dcsMigrationDateStatus]="this.dcsMigrationDateStatus"
      [oldDomesticAswSearchFlag]="this.oldDomesticAswSearchFlag"
      (changeOptionOpenEvent)="changeOptionOpen($event)"
      (changeAirport)="changeAirportEvent($event)"
      (clickStopOver)="clickStopOverEvent()"
      (changeDepartureDate)="changeDepartureDateEvent($event)"
      (showErrorMsg)="showErrorMsg()"
    ></asw-roundtrip>
  </asw-tabs-item>
  <asw-tabs-item title="{{ 'label.onewayOrMultiCitySelect' | staticMsg }}">
    <asw-oneway-or-multicity
      #onewayOrMulticityComponent
      [props]="this.props"
      [information]="information"
      [onewayInformationList]="onewayInformationList"
      [isEnabled]="this.tabIndex === 1"
      [isJapanOnlyFlag]="this.isJapanOnlyFlag"
      [dcsMigrationDateStatus]="this.dcsMigrationDateStatus"
      [oldDomesticAswSearchFlag]="this.oldDomesticAswSearchFlag"
      (changeAirport)="changeAirportEvent($event)"
      (changeDepartureDate)="changeDepartureDateEvent($event)"
    ></asw-oneway-or-multicity>
  </asw-tabs-item>
</asw-tabs>
